export default {
  INVALID_PROVIDER_PARAMETER: "INVALID_PROVIDER_PARAMETER",
  INVALID_CONTENT_ENGINE_PARAMETER: "INVALID_CONTENT_ENGINE_PARAMETER",
  SUBDOMAIN_CONFLICTED: "SUBDOMAIN_CONFLICTED",
  VENDOR_CLIENT_SID_CONFLICTED: "VENDOR_CLIENT_SID_CONFLICTED",
};
